export default "__VITE_ASSET__CYk5tlzx__"